<template>
  <ModalDefault modal_id="addTask"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_135')"
                :method="addTask"
                :footer="add_task.title && add_task.due_date && add_task.text && add_task.user_id !== null && add_task.priority_key !== null"
                icon="bx bx-task mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="row cursor-default px-2 pt-2 pb-3"  style="align-items: center; align-self: center;">
          <div class="col-md-6">
            <label class="mb-0">{{ getTranslations('expression_635') }} </label>
            <div class="input-group mb-2">
              <input type="text"
                     v-model="add_task.title"
                     class="input_forms form-control">
            </div>
          </div>
          <div class="col-md-6">
            <label class="mb-0">{{ getTranslations('expression_604') }} </label>
            <div class="input-group mb-2">
              <input type="datetime-local"
                     class="form-control input_forms"
                     :min="datetime_local_min"
                     :max="datetime_local_max"
                     name="add_task_date" v-model="add_task.due_date">
            </div>
          </div>
          <div class="col-md-12">
            <label class="mb-0">{{ getTranslations('expression_575') }} </label>
            <div class="input-group mb-2">
                <textarea class="input_forms form-control"
                          v-model="add_task.text"
                          rows="2" style="resize: none">
                </textarea>
            </div>
          </div>
          <div v-if="me.data.role_key > 0" :class="me.data.role_key > 0 ? 'col-md-6' : 'col-md-12'"
               class="col-md-6">
            <label class="mb-0">{{ getTranslations('expression_636') }} </label>
            <div class="input-group mb-2">
              <select v-model="add_task.user_id" class="input_forms custom-select" id="add_task_recipient">
                <option :value="null" disabled>{{ getTranslations('expression_637') }}</option>
                <option v-for="user in getUsersArray('channels_id', me.data.channels_id)"
                        v-if="me.data.role_key > user.role_key || me.data.id === user.id"
                        :key="user.id"
                        :value="user.id">
                  {{ user.name }}
                </option>
              </select>
            </div>
          </div>
          <div :class="me.data.role_key > 0 ? 'col-md-6' : 'col-md-12'" class="col-md-6">
            <label class="mb-0">{{ getTranslations('expression_638') }} </label>
            <div class="input-group mb-2">
              <select v-model="add_task.priority_key" class="input_forms custom-select" id="add_task_priority">
                <option disabled :value="null">{{ getTranslations('expression_639') }}</option>
                <option v-for="priority in configs.data.task_priorities"
                        :key="priority.id"
                        :value="priority.id">
                  {{ priority.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2">
        <span @click.prevent="addTask"
              data-dismiss="modal"
              class="shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3">
          <span>{{ getTranslations('expression_640') }}</span>
        </span>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import * as moment from "moment";
import $ from "jquery";

export default {
  name: "ModalAddTask",
  components: {
    ModalDefault,
  },
  computed: {
    ...mapState(['me', 'tasks', 'configs']),
    ...mapGetters([
      'getUsersArray',
      'getTranslation',
    ])
  },
  data(){
    return {
      datetime_local_min: '',
      datetime_local_max: '',
      add_task: {
        title: null,
        due_date: null,
        text: null,
        user_id: null,
        priority_key: null
      },
    }
  },
  mounted() {
    setTimeout(() => {
      this.add_task.user_id = this.me.data.id
    }, 500)
  },
  methods: {
    addTask(){
      this.add_task.me = this.me.data.id
      this.$store.dispatch('addTask', this.add_task)
      this.add_task = {
        title: null,
        due_date: null,
        text: null,
        user_id: this.me.data.id,
        priority_key: null
      }
      $('#addTask').modal('hide')
    },
    datetime_local() {
      this.datetime_local_max = moment().add(15, 'days').format().slice(0, -9)
      this.datetime_local_min = moment().add(1, 'hours').format().slice(0, -9)
    },
  }
}
</script>

<style scoped>

.form-control:disabled, .form-control[readonly] {
  background-color: #fff;
}
.custom-select:disabled {
  color: #28282d;
  background-color: #fff;
}
</style>
